import { makeStyles } from 'tss-react/mui';
import { Typography } from '@mui/material';

const useStyles = makeStyles()(theme => ({
  root: {
    marginTop: 150,
    padding: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
  },
  image: {
    display: 'inline-block',
    marginTop: 50,
    maxWidth: '100%',
    width: 560
  }
}));

let Error404 = () => {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <Typography
        align="center"
        variant="h1"
      >
        404: The page you are looking for isn’t here
      </Typography>
      <Typography
        align="center"
        variant="subtitle2"
      >
        You either tried some shady route or you came here by mistake. Whichever
        it is, try using the navigation
      </Typography>
      <img
        alt="Under development"
        className={classes.image}
        src="/images/errors/404.svg"
      />
    </div>
  );
};

export default Error404;